import connectAsync from '../../utils/connectAsync';
import { unauthenticateUser } from '../../actions/auth';
import PinCodeRouteLoader from './PinCodeRouteLoader';

export default connectAsync([unauthenticateUser])(PinCodeRouteLoader);
